import axios from 'axios';
import { getSystemMessage } from './chatGPT';

const wrapInParagraphTags = (text) => {
  const pTagRegex = /^<p>.*<\/p>$/i;

  if (pTagRegex.test(text)) return text;

  return `<p>${text}</p>`;
};

export const fetchChatGPTSimple = ({
  answer,
  language,
  model = 'gpt-5-mini',
  systemPromptAddition,
}) => {
  const systemMessage = getSystemMessage(language);
  const dataToSend = {
    model,
    messages: [
      systemMessage,
      { role: 'system', content: systemPromptAddition },
      { role: 'user', content: answer },
    ],
    temperature: 0.3,
  };

  return axios
    .post(
      'https://memowrite.app.n8n.cloud/webhook/e3d37675-59e9-4997-a8cc-f35debe71567',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data: dataToSend,
      }
    )
    .then((finalData) => {
      console.log('finalData', finalData);
      return wrapInParagraphTags(finalData.data.message.content);
    })
    .catch((error) => {
      console.log('error', error);
      return error;
    });
};

// Runs `mapper` over `items` with at most `limit` calls in flight at once.
// Results are returned in the same order as `items` (like Promise.all).
// Prevents firing all requests at once, which overwhelms the n8n webhook and
// causes later requests to time out (Cloudflare 524).
export const mapWithConcurrency = async (items, limit, mapper) => {
  const results = new Array(items.length);
  let cursor = 0;

  const worker = async () => {
    while (cursor < items.length) {
      const index = cursor++;
      results[index] = await mapper(items[index], index);
    }
  };

  const workers = Array.from({ length: Math.min(limit, items.length) }, () =>
    worker()
  );
  await Promise.all(workers);

  return results;
};

export const calculatePhotosCount = (bookQaPhotos) => {
  if (!bookQaPhotos) return 0;

  return Object.values(bookQaPhotos || {}).reduce((acc, curr) => {
    return acc + curr.length;
  }, 0);
};
